import { render, staticRenderFns } from "./Reveal.vue?vue&type=template&id=dd67bef2&scoped=true"
import script from "./Reveal.vue?vue&type=script&lang=js"
export * from "./Reveal.vue?vue&type=script&lang=js"
import style0 from "./Reveal.vue?vue&type=style&index=0&id=dd67bef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd67bef2",
  null
  
)

export default component.exports